<template>
    <div>
        <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">

            <!-- 1. Dados Pessoais -->
            <c-panel title="1. DADOS PESSOAIS" titleIcon="fas fa-id-card">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Aluno" prop="aluno_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.aluno_id"
                                       filterable remote :remote-method="searchAluno"
                                       :loading="loadingAluno" clearable
                                       placeholder="Digite o nome do aluno...">
                                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Ano" prop="ano" :rules="[$requiredBlur]">
                            <el-input v-model="dados.ano" v-mask="'####'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Semestre">
                            <el-select v-model="dados.semestre" clearable>
                                <el-option label="1º" :value="1"></el-option>
                                <el-option label="2º" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Turno">
                            <el-input v-model="dp.turno"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Ano/Série">
                            <el-input v-model="dp.ano_serie"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Data de preenchimento">
                            <el-input v-model="dados.data_preenchimento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Diagnóstico">
                            <el-input type="textarea" :rows="2" v-model="dp.diagnostico"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Local de atendimento">
                            <el-radio-group v-model="dp.local">
                                <el-radio v-for="o in $CONSTANTS.PAEE_LOCAIS" :key="o.v" :label="o.v">{{ o.l }}</el-radio>
                            </el-radio-group>
                            <el-input v-if="dp.local === 'outro'" v-model="dp.local_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Responsável">
                            <el-radio-group v-model="dp.responsavel">
                                <el-radio v-for="o in $CONSTANTS.PAEE_RESPONSAVEIS" :key="o.v" :label="o.v">{{ o.l }}</el-radio>
                            </el-radio-group>
                            <el-input v-if="dp.responsavel === 'outro'" v-model="dp.responsavel_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Profissionais que o aluno frequenta">
                            <el-checkbox-group v-model="dp.profissionais">
                                <el-checkbox v-for="o in $CONSTANTS.PAEE_PROFISSIONAIS" :key="o.v" :label="o.v">{{ o.l }}</el-checkbox>
                            </el-checkbox-group>
                            <el-input v-if="(dp.profissionais || []).indexOf('outro') >= 0" v-model="dp.profissionais_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Professor do AEE (servidor)">
                            <el-select v-model="dados.professor_aee_servidor_id"
                                       filterable remote :remote-method="searchServidor"
                                       :loading="loadingServidor" clearable
                                       placeholder="Digite o nome do servidor...">
                                <el-option v-for="s in servidores" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <!-- 2. Encaminhamento -->
            <c-panel title="2. DADOS A RESPEITO DO ENCAMINHAMENTO AO AEE" titleIcon="fas fa-paragraph">
                <el-form-item>
                    <el-input type="textarea" :rows="4" v-model="dadosForm.encaminhamento"></el-input>
                </el-form-item>
            </c-panel>

            <!-- 3. Organização -->
            <c-panel title="3. ORGANIZAÇÃO DO AEE" titleIcon="fas fa-tasks">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Tipo de atendimento">
                            <el-select v-model="org.tipo" clearable>
                                <el-option v-for="o in $CONSTANTS.PAEE_TIPOS_ATENDIMENTO" :key="o.v" :label="o.l" :value="o.v"></el-option>
                            </el-select>
                            <el-input v-if="org.tipo === 'outros'" v-model="org.tipo_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Frequência">
                            <el-select v-model="org.frequencia" clearable>
                                <el-option v-for="o in $CONSTANTS.PAEE_FREQUENCIAS" :key="o.v" :label="o.l" :value="o.v"></el-option>
                            </el-select>
                            <el-input v-if="org.frequencia === 'outro'" v-model="org.frequencia_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Duração">
                            <el-select v-model="org.duracao" clearable>
                                <el-option v-for="o in $CONSTANTS.PAEE_DURACOES" :key="o.v" :label="o.l" :value="o.v"></el-option>
                            </el-select>
                            <el-input v-if="org.duracao === 'outro'" v-model="org.duracao_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <!-- 4-8. Áreas de Desenvolvimento -->
            <c-panel v-for="area in $CONSTANTS.PAEE_AREAS" :key="area.v" :title="'ÁREA — ' + area.l.toUpperCase()" titleIcon="fas fa-layer-group">
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição">
                            <el-input type="textarea" :rows="2" v-model="getArea(area.v).descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Objetivo">
                            <el-input type="textarea" :rows="2" v-model="getArea(area.v).objetivo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- Campos extras de Linguagem -->
                <template v-if="area.v === 'linguagem'">
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item label="Forma atual de comunicação">
                                <el-checkbox-group v-model="getArea(area.v).forma_comunicacao">
                                    <el-checkbox v-for="o in $CONSTANTS.PAEE_FORMA_COMUNICACAO" :key="o.v" :label="o.v">{{ o.l }}</el-checkbox>
                                </el-checkbox-group>
                                <el-input v-if="(getArea(area.v).forma_comunicacao || []).indexOf('outras') >= 0" v-model="getArea(area.v).forma_comunicacao_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item label="Quem entende">
                                <el-radio-group v-model="getArea(area.v).quem_entende">
                                    <el-radio v-for="o in $CONSTANTS.PAEE_QUEM_ENTENDE" :key="o.v" :label="o.v">{{ o.l }}</el-radio>
                                </el-radio-group>
                                <el-input v-if="getArea(area.v).quem_entende === 'outros'" v-model="getArea(area.v).quem_entende_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>

                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="primary" plain icon="el-icon-plus" @click="addLinha(area.v)" size="small">ADICIONAR LINHA</el-button>
                    </el-col>
                </el-row>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Conteúdo específico</th>
                            <th>Flexibilização</th>
                            <th>Avaliação</th>
                            <th style="width: 70px;">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(linha, idx) in getArea(area.v).tabela" :key="idx">
                            <td><el-input type="textarea" :rows="2" v-model="linha.conteudo"></el-input></td>
                            <td><el-input type="textarea" :rows="2" v-model="linha.flexibilizacao"></el-input></td>
                            <td><el-input type="textarea" :rows="2" v-model="linha.avaliacao"></el-input></td>
                            <td class="u-text-center">
                                <el-button @click="removeLinha(area.v, idx)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!getArea(area.v).tabela.length">
                            <td colspan="4" class="u-text-center" style="padding: 12px; color: #999;">Nenhuma linha. Clique em "ADICIONAR LINHA".</td>
                        </tr>
                    </tbody>
                </table>
            </c-panel>

            <!-- 9. Estratégias gerais -->
            <c-panel title="9. ESTRATÉGIAS GERAIS" titleIcon="fas fa-lightbulb">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" v-for="campo in estrategiasCampos" :key="campo.v">
                        <el-form-item :label="campo.l">
                            <el-input type="textarea" :rows="2" v-model="estr[campo.v]"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <!-- 10/11. Avaliação final -->
            <c-panel title="10/11. AVALIAÇÃO FINAL (2º SEMESTRE)" titleIcon="fas fa-clipboard-check">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" v-for="campo in avalCampos" :key="campo.v">
                        <el-form-item :label="campo.l">
                            <el-input type="textarea" :rows="2" v-model="af[campo.v]"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Conclusão">
                            <el-input type="textarea" :rows="3" v-model="af.conclusao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="12">
                    <el-form-item>
                        <el-checkbox v-model="dados.finalizado">Marcar como finalizado</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button v-if="dados.id" type="primary" @click="imprimir">IMPRIMIR</el-button>
                    <el-button class="u-ml-10" type="primary" id="btn-paee" native-type="submit">SALVAR</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
const novaArea = () => ({ descricao: '', objetivo: '', tabela: [] })
const novaAreaLinguagem = () => ({ descricao: '', objetivo: '', tabela: [], forma_comunicacao: [], forma_comunicacao_outro: '', quem_entende: '', quem_entende_outro: '' })

export default {
    props: ['paramId'],
    data: () => ({
        edit: false,
        loadingAluno: false,
        loadingServidor: false,
        alunos: [],
        servidores: [],
        estrategiasCampos: [
            { v: 'ambiente_estruturado', l: 'Ambiente estruturado' },
            { v: 'suporte_visual', l: 'Suporte visual' },
            { v: 'comunicacao_alternativa', l: 'Comunicação alternativa' },
            { v: 'reforco_positivo', l: 'Reforço positivo' },
            { v: 'autorregulacao', l: 'Autorregulação' },
            { v: 'sensibilidade_sensorial', l: 'Sensibilidade sensorial' },
            { v: 'intervencoes_sociais', l: 'Intervenções sociais' },
            { v: 'flexibilidade_cognitiva', l: 'Flexibilidade cognitiva' },
        ],
        avalCampos: [
            { v: 'motor', l: 'Desenvolvimento Motor' },
            { v: 'linguagem', l: 'Linguagem' },
            { v: 'cognicao', l: 'Cognição' },
            { v: 'autocuidados', l: 'Autocuidados' },
            { v: 'socializacao', l: 'Socialização e Desenv. Emocional' },
        ],
        dados: {
            id: '',
            aluno_id: '',
            instituicao_id: null,
            ano: new Date().getFullYear(),
            semestre: null,
            periodo_letivo_id: null,
            professor_aee_servidor_id: null,
            data_preenchimento: '',
            finalizado: false,
            dados: null
        },
        dadosForm: {
            encaminhamento: ''
        },
        dp: { turno: '', ano_serie: '', diagnostico: '', local: '', local_outro: '', profissionais: [], profissionais_outro: '', responsavel: '', responsavel_outro: '' },
        org: { tipo: '', tipo_outro: '', frequencia: '', frequencia_outro: '', duracao: '', duracao_outro: '' },
        areas: {
            motor: novaArea(),
            linguagem: novaAreaLinguagem(),
            cognicao: novaArea(),
            autocuidados: novaArea(),
            socializacao: novaArea()
        },
        estr: {},
        af: {}
    }),
    methods: {
        getArea (chave) {
            if (!this.areas[chave]) {
                this.$set(this.areas, chave, chave === 'linguagem' ? novaAreaLinguagem() : novaArea())
            }
            return this.areas[chave]
        },
        addLinha (chave) {
            this.getArea(chave).tabela.push({ conteudo: '', flexibilizacao: '', avaliacao: '' })
        },
        removeLinha (chave, idx) {
            this.getArea(chave).tabela.splice(idx, 1)
        },
        searchAluno (query) {
            if (!query) { this.alunos = []; return }
            this.loadingAluno = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.alunos = response.data || []
            }).catch(() => {}).finally(() => { this.loadingAluno = false })
        },
        searchServidor (query) {
            if (!query) { this.servidores = []; return }
            this.loadingServidor = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.servidores = response.data || []
            }).catch(() => {}).finally(() => { this.loadingServidor = false })
        },
        getById (id) {
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/plano-paee/getById/` + id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    const r = response.data || {}
                    this.dados = Object.assign({}, this.dados, {
                        id: r.id, aluno_id: r.aluno_id, instituicao_id: r.instituicao_id,
                        ano: r.ano, semestre: r.semestre, periodo_letivo_id: r.periodo_letivo_id,
                        professor_aee_servidor_id: r.professor_aee_servidor_id,
                        data_preenchimento: r.data_preenchimento ? this.$moment(r.data_preenchimento).format('DD/MM/YYYY') : '',
                        finalizado: !!r.finalizado
                    })
                    if (r.aluno) this.alunos = [r.aluno]
                    if (r.professor_aee) this.servidores = [r.professor_aee]
                    const d = r.dados || {}
                    this.dp = Object.assign({ turno: '', ano_serie: '', diagnostico: '', local: '', local_outro: '', profissionais: [], profissionais_outro: '', responsavel: '', responsavel_outro: '' }, d.dados_pessoais || {})
                    this.dadosForm.encaminhamento = d.encaminhamento || ''
                    this.org = Object.assign({ tipo: '', tipo_outro: '', frequencia: '', frequencia_outro: '', duracao: '', duracao_outro: '' }, d.organizacao || {})
                    const areasIn = d.areas || {}
                    Object.keys(this.areas).forEach(k => {
                        const base = k === 'linguagem' ? novaAreaLinguagem() : novaArea()
                        this.$set(this.areas, k, Object.assign(base, areasIn[k] || {}))
                        if (!Array.isArray(this.areas[k].tabela)) this.areas[k].tabela = []
                    })
                    this.estr = Object.assign({}, d.estrategias || {})
                    this.af = Object.assign({}, d.avaliacao_final || {})
                }).catch((error) => { this.$store.commit('throwException', error) })
                .finally(() => { window.eventBus.$emit('loading', false) })
        },
        buildPayload () {
            const inst = this.$store.state.config && this.$store.state.config.instituicao ? this.$store.state.config.instituicao : null
            const dataFormatada = this.dados.data_preenchimento && this.$moment(this.dados.data_preenchimento, 'DD/MM/YYYY', true).isValid()
                ? this.$moment(this.dados.data_preenchimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                : null
            return {
                aluno_id: this.dados.aluno_id,
                instituicao_id: inst ? inst.id : this.dados.instituicao_id,
                ano: parseInt(this.dados.ano) || new Date().getFullYear(),
                semestre: this.dados.semestre || null,
                periodo_letivo_id: this.dados.periodo_letivo_id,
                professor_aee_servidor_id: this.dados.professor_aee_servidor_id,
                data_preenchimento: dataFormatada,
                finalizado: !!this.dados.finalizado,
                dados: {
                    dados_pessoais: this.dp,
                    encaminhamento: this.dadosForm.encaminhamento,
                    organizacao: this.org,
                    areas: this.areas,
                    estrategias: this.estr,
                    avaliacao_final: this.af
                }
            }
        },
        onSubmit () {
            document.getElementById('btn-paee').focus()
            this.$refs.dados.validate((valid) => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const payload = this.buildPayload()
                const url = this.edit
                    ? `${this.$store.state.config.baseUrlApi}/api/plano-paee/update/` + this.dados.id
                    : `${this.$store.state.config.baseUrlApi}/api/plano-paee/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        window.eventBus.$emit('loading', false)
                        if (response.data && response.data.erro) {
                            const t = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
                            window.eventBus.$emit('alert', { msg: t, type: 'warning' })
                            return
                        }
                        window.eventBus.$emit('alert', { msg: 'PAEE/AEE salvo com sucesso.', type: 'success' })
                        this.$emit('onSubmit')
                    })
                    .catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
            })
        },
        imprimir () {
            if (!this.dados.id) return
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/plano-paee/imprimir/${this.dados.id}`,
                this.$store.getters.getHeaderAuthExcel
            ).then(response => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if (value) {
                    this.edit = true
                    this.getById(value)
                }
            }
        }
    }
}
</script>
